import {Screen} from "./screen.api";
import {Domznak} from "./domznak.api";

export const Processor = {
    screen: new Screen(),
    domznak: new Domznak()
};